<script setup lang="ts">
import {
    onMounted,
    provide,
    unref,
    watch,
} from 'vue';

import type {
    NavTabsSimpleParent,
    TabButtonType,
} from './injection';
import { NavTabsSimpleParentKey } from './injection';

const props = defineProps<{
    modelValue?: string;
    tabsClass?: string;
}>();
const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void;
}>();

let activeButton: string | undefined;
const buttonsArray: TabButtonType[] = [];

function activateButton() {
    buttonsArray.forEach((button) => {
        button.active.value = (button.idRef.id === activeButton);
    });
}
const tabsParent: NavTabsSimpleParent = {
    registerButton(button) {
        buttonsArray.push(button);
    },
    unregisterButton(idRef) {
        const index = buttonsArray.findIndex((button) => button.idRef.id === idRef.id);
        if(index >= 0) buttonsArray.splice(index, 1);
    },
    activateButton(idRef) {
        activeButton = idRef.id;
        activateButton();
        emit('update:modelValue', activeButton);
    },
};
provide(NavTabsSimpleParentKey, tabsParent);


watch(() => props.modelValue, (value) => {
    if(activeButton !== value) {
        activeButton = value;
        activateButton();
    }
});

onMounted(() => {
    if(props.modelValue) {
        activeButton = props.modelValue;
        activateButton();
    } else {
        //simulate activation for first initiallyActive
        const _activeButton = buttonsArray.find((button) => unref(button.active));
        if(_activeButton) {
            tabsParent.activateButton?.(_activeButton.idRef);
        }
    }
});
</script>

<template>
    <div>
        <ul :class="props.tabsClass ? props.tabsClass : 'nav nav-pills'" role="tablist">
            <slot name="buttons" />
        </ul>
        <div class="tab-content">
            <slot />
        </div>
    </div>
</template>
